import {
  Component
} from '@angular/core';
import { AsyncSubject } from 'rxjs';
import * as _ from 'lodash';

import * as utils from 'utils/utils';


export class BaseSegmentMixin {

  data: any;
  headers: any;

  public getFieldValue(item: any, field: any): string {
    return utils.getFieldValue(item, field);
  }

  public getFieldTitle(name: string): string {
    return utils.getFieldTitle(name, this.data);
  }

  public isHeader(name: string): boolean {
    return _.indexOf(this.headers, name) >= 0;
  }

  protected pickOutShowMoreData(data: any) {
    const groupedData = _.groupBy(data, (item: any) => item.show_more);
    this.data = (<any>groupedData)['true'];
    (<any>this)['showMoreData'] = (<any>groupedData)['false'];
  }

  protected orderBy(data: any, property: string = 'sequence'): any {
    if (!data || !data.length) { return; }
    return _.orderBy(data, property);
  }
}
